import { defineStore } from 'pinia';
// import { useStoreCompat } from "@/composables/useStoreCompat";

export const useDatesAndLocationsStore = defineStore('datesAndLocations', () => {

  // const store = useStoreCompat();

  let dateAndLocation = {
    moment: {},
    preUbicacion: {}
  }
 
  const updateData = async (dataType, payload) => {
    try {
      dateAndLocation[dataType] = payload;
    } catch (e) {
      console.error("Error al actualizar 'dateAndLocation':", e);
    }
  }

  return {
    updateData,
    dateAndLocation
  };
});